"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseField = void 0;
var React = __importStar(require("react"));
var CollapseFieldInput_1 = require("./CollapseFieldInput");
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var icons_1 = require("@epic-ui/icons");
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var fieldHeight = 40;
var useStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions;
    return ({
        root: {
            "&:hover $label": {
                color: palette.text.primary,
            },
        },
        label: {
            lineHeight: 1,
            position: "static",
            marginBottom: "-1em",
            marginLeft: spacing(7),
            alignSelf: "flex-start",
            transform: "translateY(calc(" + fieldHeight / 2 + "px - 50%))",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            maxWidth: "calc(100% - " + spacing(7) + "px)",
            transition: [
                transitions.create("opacity", {
                    duration: transitions.duration.short,
                }),
                transitions.create("color", {
                    duration: transitions.duration.shorter,
                }),
            ].join(),
            pointerEvents: "none",
            "&[class*='MuiFormLabel-filled'], &.Mui-focused, $root:focus-within &": {
                opacity: 0,
            },
        },
    });
}, { name: "EuiCollapseField" });
exports.CollapseField = React.forwardRef(function CollapseField(props, ref) {
    var autoComplete = props.autoComplete, autoFocus = props.autoFocus, classesProp = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.error, error = _b === void 0 ? false : _b, _c = props.expandWidth, expandWidth = _c === void 0 ? 280 : _c, FormHelperTextProps = props.FormHelperTextProps, fullWidth = props.fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, _d = props.InputLabelProps, _e = _d === void 0 ? {
        className: undefined,
    } : _d, labelClassName = _e.className, InputLabelProps = __rest(_e, ["className"]), inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _f = props.required, required = _f === void 0 ? false : _f, _g = props.startIcon, startIcon = _g === void 0 ? React.createElement(icons_1.Search, { fontSize: "small" }) : _g, type = props.type, value = props.value, other = __rest(props, ["autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "error", "expandWidth", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "startIcon", "type", "value"]);
    var classes = useStyles({ expandWidth: expandWidth });
    var helperTextId = helperText && id ? id + "-helper-text" : undefined;
    var inputLabelId = label && id ? id + "-label" : undefined;
    return (React.createElement(FormControl_1.default, __assign({ className: clsx_1.default(classes.root, classesProp === null || classesProp === void 0 ? void 0 : classesProp.root, className), color: color, disabled: disabled, error: error, fullWidth: fullWidth, hiddenLabel: hiddenLabel, ref: ref, required: required, variant: "standard" }, other),
        label && (React.createElement(InputLabel_1.default, __assign({ htmlFor: id, id: inputLabelId, shrink: false, className: clsx_1.default(classes.label, labelClassName) }, InputLabelProps), label)),
        React.createElement(CollapseFieldInput_1.CollapseFieldInput, __assign({ "aria-describedby": helperTextId, autoComplete: autoComplete, 
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: autoFocus, defaultValue: defaultValue, disableUnderline: true, expandWidth: expandWidth, fieldHeight: fieldHeight, fullWidth: fullWidth, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, startIcon: startIcon, type: type, value: value }, InputProps)),
        helperText && (React.createElement(FormHelperText_1.default, __assign({ id: helperTextId }, FormHelperTextProps), helperText))));
});
//# sourceMappingURL=CollapseField.js.map